import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
// import qs from "qs";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getProducts(params) {
	return client.get("product/data", {
		params: params,
	});
}

function getProductsSearch(params) {
	return client.get("product/data-search", {
		params: params,
	});
}

function getProductInternal(params) {
	return client.get("product/data-internal", {
		params: params,
	});
}

function getProductExternal(params) {
	return client.get("product/data-external", {
		params: params,
	});
}

function getProductMostViewed(params) {
	return client.get("product/data-most-viewed", {
		params: params,
	});
}

function getProductMostBuy(params) {
	return client.get("product/data-most-bought", {
		params: params,
	});
}

function getDetailProduct(params) {
	return client.get("product/detail", {
		params: params,
	});
}

function getProductByStore(params) {
	return client.get("product/data-by-store", {
		params: params,
	});
}

function getProductTrend(params) {
	return client.get("product/data-trend", {
		params: params,
	});
}

export default {
	getProducts,
	getProductsSearch,
	getProductInternal,
	getProductExternal,
	getProductMostViewed,
	getProductMostBuy,
	getDetailProduct,
	getProductByStore,
	getProductTrend
};